import { FC, PropsWithChildren, createContext, useContext, useState } from "react";

type TempPasswordContextType = {
  tempPassword?: string;
  setTempPassword: (newPassword: string) => void;
};

const TempPasswordContext = createContext<TempPasswordContextType>({
  setTempPassword: () => {},
});

export const TempPasswordProvider: FC<PropsWithChildren> = ({ children }) => {
  const [tempPassword, setTempPassword] = useState<string>();

  return (
    <TempPasswordContext.Provider
      value={{
        tempPassword,
        setTempPassword,
      }}
    >
      {children}
    </TempPasswordContext.Provider>
  );
};

export const useTempPassword = () => {
  return useContext(TempPasswordContext);
};
